module.exports = __webpack_public_path__ + "img/286910253.58d9dee9.jpg";